import { Helmet } from 'react-helmet-async';

import { config } from '../../config';

interface Props {
  readonly text: string | string[];
}

export function HtmlTitle(p: Props) {
  const parts = Array.isArray(p.text) ? p.text : [p.text];
  const title = `${parts.join(' | ')} | MediaInbox` + (config.isAppDev ? ' (DEV)' : '');

  return (
    <Helmet defer={false}>
      <title>{title}</title>
    </Helmet>
  );
}
